<template>
  <v-row>
    <v-col class="mt-2" cols="12" lg="12">
      <v-row>
        <v-col lg="10" offset-lg="1" class="mt-2" cols="12">
          <v-breadcrumbs :items="items" divider=">" class="ml-n6" />
        </v-col>

        <v-col cols="12" class="offset-lg-1" lg="10">
          <v-card>
            <v-card-title class="theme white--text">
              <v-icon class="white--text mr-2">card_membership</v-icon>
              Activate subscription
              <v-spacer></v-spacer>
              <v-btn depressed @click="startBillingSession" class="action rounded-sm white--text">subscription history
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-simple-table class="mx-3 mt-4" dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="body-1">Features</th>
                      <th class="body-1">Description</th>
                      <th class="body-1">Included</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in card.features" :key="item.name">
                      <td class="body-2">{{ item.name }}</td>
                      <td class="body-2 grey--text">
                        <span>{{ item.coming_soon }}</span>
                      </td>
                      <td>
                        <v-icon v-if="item.included" small class="success--text">done</v-icon>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <!-- <v-list dense> -->
                <v-subheader class="title mt-1 ml-3">Pricing details</v-subheader>
                <div class="ml-7">Please check our pricing details <a target="_blank" class="theme-text text-decoration-none" href="https://www.lessadmin.com/pricing">here</a>.</div>
                <!-- <v-list-item>
                  <v-list-item-content>
                    <ul v-for="price in card.pricePerUser" :key="price">
                      <li class="grey--text text--darken-1 subtitle-2">
                        {{ price }}
                      </li>
                    </ul>
                  </v-list-item-content>
                </v-list-item> -->
              <!-- </v-list> -->
            </v-card-text>
            <v-card-actions>
              <v-btn class="ml-5 mb-3 action white--text rounded-sm" depressed
                v-if="'active' !== membershipStatus || 'Registered' === membershipStatus" @click="openWarning">
                activate subscription
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" lg="10" offset-lg="1" v-if="paymentMethods.length > 0">
          <v-card>
            <v-card-title class="theme white--text">
              <v-icon class="white--text mr-2">credit_card</v-icon> Your Payment
              Methods
            </v-card-title>
            <v-card-text class="pt-3">
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Brand</th>
                      <th class="text-left">Card</th>
                      <th class="text-left">Default</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in paymentMethods" :key="item.name">
                      <td class="text-capitalize">{{ item.brand }}</td>
                      <td>XXXX - XXXX - XXXX - {{ item.card }}</td>
                      <td>{{ item.is_default }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>

    <v-dialog v-model="dialog" persistent max-width="550">
      <v-card>
        <v-card-title class="headline theme-text">
          <div class="text-center">Activate {{ card.title }} subscription?</div>
        </v-card-title>
        <v-divider />
        <v-card-text class="my-5 subtitle-1">
          <div>
            You are choosing to activate the membership type
            {{ card.title }}. You will be charged for selecting this as per
            <a href="https://lessadmin.com/terms/terms-and-conditions" class="text-decoration-none theme-text"
              target="_blank">
              terms and conditions.</a>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn color="green darken-1" text @click="dialog = false">Cancel</v-btn>
          <v-spacer />
          <v-btn color="orange darken-1" text @click="save">Agree</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";
import { TableHeaders } from "@/views/headers";

export default {
  name: Component.Protected.Company.Membership.List,
  computed: {
    ...mapGetters(["userInfo", "company"]),
  },
  data: () => ({
    card: {
      title: "Monthly",
      subtitle: "Invoice generated monthly",
      features: [
        {
          name: "Employee management",
          included: true,
          coming_soon: "Add and remove employees from company",
        },
        {
          name: "Announcements",
          included: true,
          coming_soon: "Create company-wide announcements",
        },
        {
          name: "Backoffice - intranet & document sharing",
          included: true,
          coming_soon:
            "Create rich text documents for managing company knowledge base",
        },
        {
          name: "Custom Benefits",
          included: true,
          coming_soon: "Create benefit list for employees",
        },
        {
          name: "Timeoff and leave planner",
          included: true,
          coming_soon:
            "Timeoff management for the employees across several countries",
        },
        {
          name: "Onboarding and offboarding",
          included: true,
          coming_soon:
            "Custom workflows for employee onboarding and offboarding",
        },
        {
          name: "Premium benefits",
          included: true,
          coming_soon: "Chose benefits from our market place",
        },
        { name: "Reports", included: true, coming_soon: "Coming soon" },
        { name: "Integrations", included: true, coming_soon: "Coming soon" },
      ],
      pricePerUser: [
        "Monthly pay as you go plan",
        "Upto 10 employees : NOK 30 (flat fee)",
        "11 to 20 employees : NOK 4 per employee",
        "Over 20 employees :  NOK 3 per employee",
        "Registered card required. One time fee of 1 EUR will be charged",
      ],
      type: "Monthly",
    },

    items: Breadcrumbs.Membership,
    membershipStatus: "active",
    activate: null,
    dialog: false,
    tableHeaders: TableHeaders.Membership,
    paymentMethods: [],
  }),
  methods: {
    startBillingSession() {
      this.$store.dispatch(Actions.Company.BillingSession).then((r) => {
        if (r.status === 200 && r.data) {
          if (r.data === "CUSTOMER_NOT_FOUND") {
            this.$emit(Constants.Events.Alert, {
              show: true,
              type: "warning",
              message: "Your company is not registered yet. Please contact admin",
              component: null,
            });
          } else {
            window.location = r.data;
          }
        }
      });
    },
    resetModels() {
      this.dialog = false;
      this.membershipStatus = null;
    },
    openWarning() {
      this.dialog = true;
    },
    save() {
      this.$store
        .dispatch(Actions.CompanyAddMembership, {
          activate: true,
          membership: this.card.title,
        })
        .then((res) => {
          if (res.status === 200 && res.data) {
            if (res.data.code === "subscription_exists") {
              this.$emit(Constants.Events.Alert, {
                show: true,
                type: "info",
                message: "Your subscription is already active",
                component: null,
              });
            } else if (res.data.code === "CUSTOMER_NOT_FOUND") {
              this.$emit(Constants.Events.Alert, {
                show: true,
                type: "warning",
                message: "Your company is not registered yet. Please contact admin",
                component: null,
              });
            } else {
              window.location = res.data;
            }
          }
        })
        .finally(() => {
          this.dialog = false;
          this.getMembershipInfo();
          this.$store.dispatch(Actions.Company.Info);
          this.$forceUpdate();
        });
    },

    getMembershipInfo() {
      this.$store.dispatch(Actions.Company.MembershipInfo).then((res) => {
        if (res.status === 200) {
          this.paymentMethods = res.data.payment_methods;
          this.membershipStatus = res.data.status;
        }
      });
    },
    setup() {
      if (this.userInfo.role !== Constants.Roles.HR) {
        this.$router.go(-1);
        return false;
      }
      if (this.$route.query.session_id) {
        this.$emit(Constants.Events.Alert, {
          show: true,
          type: "success",
          message: "Membership activated. You can now close this alert",
          component: null,
        });
        let query = Object.assign({}, this.$route.query);
        delete query.session_id;
        this.$router.replace({ query });
      }

      if (this.$route.query.session_cancelled) {
        // reset the subscription
        this.$store.dispatch(Actions.Company.MembershipSessionCancelled)
          .then(r => {
            if (r.status === 200) {
              let query = Object.assign({}, this.$route.query);
              delete query.session_cancelled;
              this.$router.replace({ query });
              console.log("Calling company info")
              this.$store.dispatch(Actions.Company.Info)
            }
          })

      }

      this.resetModels();
      this.getMembershipInfo();
    },
  },
  created() {
    if (this.userInfo && this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>